/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * @param {PositionDirections} direction
 * @param {number} sourceIndex
 * @param {number} numQuestions
 */
const getTargetIndex = (direction, sourceIndex, numQuestions) => {
    const incAmount = direction === "down" ? 1 : -1;
    let targetIndex = sourceIndex + incAmount;

    // ensure minimum boundary (0-based)
    targetIndex = Math.max(0, targetIndex);

    // ensure maximum boundary (0-based)
    targetIndex = Math.min(
        numQuestions - 1,
        targetIndex
    );

    return targetIndex;
};

export { getTargetIndex };
